import { writable } from "svelte/store";

export const sidebarIsExpanded = writable(false);

export const showUpgradeModal = writable(false);
